import * as React from "react";
import * as QRCode from "qrcode";

interface QRCodeViewProps {
    text: string;
}

export default class QRCodeView extends React.Component<QRCodeViewProps> {
    myRef: React.RefObject<unknown>;
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    componentDidMount() {
        QRCode.toCanvas(
            this.myRef.current,
            this.props.text,
            () => {}
        );
    }

    render() {
        //@ts-ignore
        return <canvas ref={this.myRef} height="100" width="100"></canvas>;
    }
}
